import styled from "styled-components/macro";

const InputField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export default InputField;
